module.exports = __webpack_public_path__ + "static/media/capstone_permissions.a0eca7f6.yaml";